import React, {Component} from "react"

import Flex from "@irati/ui/src/Flex"
import {adminDashboardTracking} from "@irati-tracking/admin"
import {H3} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import theme from "@irati/ui/src/global/theme"
import {ButtonRouterLink} from "@irati/ui/src/Link"

import BusinessStatisticSection from "./BusinessStatisticSection"
import {VIEW_TEAM, VIEW_BUSINESS_UNITS, VIEW_PEOPLE, ANALYTICS_OVERALL} from "../../../routes/routeConfig"

interface Props {
  regions: number,
  teams: number,
  users: number
}

class BusinessStatistics extends Component<Props> {
  render(){
    const {regions, teams, users} = this.props

    return <>
      <Flex justifyContent="space-between" alignItems="flex-end" marginBottom={2}>
        <H3>
          <FormattedMessage id="admin.components.businessStatistics.title" />
        </H3>
        <ButtonRouterLink primary to={ANALYTICS_OVERALL}>
          <FormattedMessage id="admin.components.businessStatistics.link" />
        </ButtonRouterLink>
      </Flex>

      <Flex gap={theme.spacing.one} id="adminSection_businessStatistics">
        <BusinessStatisticSection
          id="adminSection__businessStatistics_editRegionsId"
          title="admin.components.businessStatistics.countries.title"
          amount={regions}
          buttonText="admin.components.businessStatistics.countries.button"
          page={VIEW_BUSINESS_UNITS}
          onButtonClick={adminDashboardTracking.clickAddRegionCTA} />
        <BusinessStatisticSection
          id="adminSection__businessStatistics_editTeamId"
          title="admin.components.businessStatistics.teams.title"
          amount={teams}
          buttonText="admin.components.businessStatistics.teams.button"
          page={VIEW_TEAM}
          onButtonClick={adminDashboardTracking.clickCreateTeamsCTA} />
        <BusinessStatisticSection
          id="adminSection__businessStatistics_editPeopleId"
          title="admin.components.businessStatistics.people.title"
          amount={users}
          buttonText="admin.components.businessStatistics.people.button"
          page={VIEW_PEOPLE}
          onButtonClick={adminDashboardTracking.clickAddPeopleCTA} />
      </Flex>
    </>
  }
}

export default BusinessStatistics
